







































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  @Prop({ type: String, default: 'none' })
  public status!: string;

  private get stroke(): string {
    if (this.status === 'mask') return '#000000';
    if (this.status === 'capture') return '#3cf5ff';
    if (this.status === 'success') return '#43e21c';
    return '#ffffff';
  }

  private get fillMask(): string {
    if (this.status === 'mask') return '#000000';
    return 'transparent';
  }

  // 手がない方の斜め撮影画像と本人確認書類位置を合わせるための変形
  private get transformStyle(): { [key: string]: string } {
    const tx: number = -25;
    const ty: number = -11;
    const sx: number = 356 / 328;
    const sy: number = 140 / 125;
    return { transform: `translate(${tx}px, ${ty}px) scale(${sx}, ${sy})` };
  }
}
